import { Dropdown } from '@eventbrite/eds-containers';
import { IconButton } from '@eventbrite/eds-icon-button';
import { VerticalDotsChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { AnalyticsContext, ApplicationContext } from '../context';
import { AnalyticsAction, AnalyticsCategory, trackEvent } from '../_shared';
import { CopyUrlButton } from './CopyUrlButton';

export const OrganizerBottomActions: React.FC = () => {
    const { collectionId, organizerId } = useContext(AnalyticsContext);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [mobileMoreActionsVisible, setmobileMoreActionsVisible] = useState(
        false,
    );
    const context = useContext(ApplicationContext);
    const promoteLink = `/organizations/marketing/boost-collection?collection_id=${context?.collection.id}&utm_source=collection-promote-cta&source=organizer-bottom-actions`;
    const editLink = `/manage/collections/${context?.collection.id}/publish`;
    const element = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const elHeight = element.current?.offsetHeight;
        const body = document.querySelector('body');

        if (body) {
            body.style.paddingBottom = `${elHeight}px`;
        }
    }, []);

    const onPromoteCollectionClick = (position: string) => {
        trackEvent({
            category: AnalyticsCategory.Listing,
            action: AnalyticsAction.CollectionPromote,
            label: position,
            dimensions: {
                collectionId,
                organizerId,
            },
        });
    };

    return (
        <div ref={element} className="cc-organizer-actions">
            <div className="cc-organizer-actions__wrapper">
                <div className="eds-show-down-mn cc-organizer-actions__mobile-dropdown">
                    <IconButton
                        iconColor="control"
                        iconType={<VerticalDotsChunky />}
                        title={gettext('More actions')}
                        style="outline"
                        onClick={() => setmobileMoreActionsVisible(true)}
                    />
                    {mobileMoreActionsVisible && (
                        <Dropdown
                            dropUp={true}
                            onClickOutside={() =>
                                setmobileMoreActionsVisible(false)
                            }
                        >
                            <div className="eds-l-pad-all-4">
                                <ul className="cc-organizer-actions__mobile-list">
                                    <li className="cc-organizer-actions__mobile-item eds-show-down-sm">
                                        <a
                                            href={promoteLink}
                                            onClick={() =>
                                                onPromoteCollectionClick(
                                                    'bottom-actions',
                                                )
                                            }
                                        >
                                            {gettext('Promote this collection')}
                                        </a>
                                    </li>
                                    <li className="cc-organizer-actions__mobile-item">
                                        <CopyUrlButton />
                                    </li>
                                    <li className="cc-organizer-actions__mobile-item">
                                        <a
                                            href={editLink}
                                            onClick={() => {
                                                trackEvent({
                                                    action:
                                                        AnalyticsAction.EditCollection,
                                                    label: 'bottom-actions',
                                                    category:
                                                        AnalyticsCategory.Listing,
                                                    dimensions: {
                                                        collectionId,
                                                        organizerId,
                                                    },
                                                });
                                            }}
                                        >
                                            {gettext('Edit this collection')}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </Dropdown>
                    )}
                </div>
                <ul className="cc-organizer-actions__list">
                    <li className="cc-organizer-actions__item eds-show-up-md">
                        <CopyUrlButton />
                    </li>
                    <li className="cc-organizer-actions__item eds-show-up-sw">
                        <div className="cc-tooltip">
                            <a
                                id="tooltip-label"
                                href={promoteLink}
                                className="eds-btn eds-btn--link cc-tooltip__trigger"
                                aria-describedby="tooltip"
                                onClick={() =>
                                    onPromoteCollectionClick('organizer-banner')
                                }
                                onFocus={() => setTooltipVisible(true)}
                                onBlur={() => setTooltipVisible(false)}
                            >
                                {gettext('Promote this collection')}
                            </a>
                            <div
                                aria-hidden={!tooltipVisible}
                                role="tooltip"
                                aria-labelledby="tooltip-label"
                                id="tooltip"
                                className="cc-tooltip__message"
                            >
                                {gettext(
                                    'Boost attendance to your events within this collection with a paid social campaign.',
                                )}
                            </div>
                        </div>
                    </li>
                    <li className="cc-organizer-actions__item">
                        <a
                            href="/organizations/collections"
                            className="eds-btn eds-btn--link"
                            aria-describedby="tooltip"
                        >
                            {gettext('View your collections')}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};
